module.exports = __webpack_public_path__ + "img/w62b.87c00c07.jpg";